"use strict";
export var SafetyLevel = /* @__PURE__ */ ((SafetyLevel2) => {
  SafetyLevel2["BLOCKED"] = "BLOCKED";
  SafetyLevel2["MEDIUM_WARNING"] = "MEDIUM_WARNING";
  SafetyLevel2["STRONG_WARNING"] = "STRONG_WARNING";
  SafetyLevel2["VERIFIED"] = "VERIFIED";
  return SafetyLevel2;
})(SafetyLevel || {});
